<div class="map-kpi-container">
    <div id="routeTable" class="route-sidebar" [ngClass]="{'collapsed': isTableCollapsed()}">
        <div class="table-container">
            <div class="left-panel-header">
                <div class="dropdown">
                    <p-select [options]="viewOptions" [ngModel]="selectedView()" (onChange)="selectView($event)">
                    </p-select>
                </div>
                <!--Collapse route table icon-->
                @if(!isTableCollapsed()){
                    <div class="collapse-toggle" (click)="toggleTable()" [pTooltip]="'collapse'">
                        <i class="pi pi-angle-left"></i>
                    </div>
                }
                
            </div>
            @defer(when kpiData().length){
                <p-table [value]="kpiData()" dataKey="route_id" [rowHover]="true"
                    selectionMode="multiple"
                    [metaKeySelection]="false"
                    [(selection)]="dataRepositoryService.selectedRouteList"
                    (selectionChange)="routeSelect($event)"
                    [scrollable]="true" scrollHeight="flex"
                    [virtualScroll]="true" [virtualScrollItemSize]="34"
                    [loading]="loading()" #mapTable>
                    <ng-template pTemplate="loadingicon">
                        <i class="pi pi-spin pi-spinner fs-2 fw-bold"></i>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th scope="col" class="resetButtonCol">
                                <button class="btn btn-xs resetButton btn-secondary" type="button"
                                    [hidden]="dataRepositoryService.selectedRouteList.length ? false : true"
                                    (click)="deselectAll()">Reset
                                </button>
                            </th>
                            <th pSortableColumn="route_label" scope="col">Route<p-sortIcon field="route_label" /></th>
                            <th pSortableColumn="route_state" scope="col">Status<p-sortIcon field="route_state" /></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-kpiData let-rowData="rowData" let-rowIndex="rowIndex">
                        <tr [pSelectableRow]="kpiData" [pSelectableRowIndex]="rowIndex">
                            <td>
                                <p-tableCheckbox [disabled]="(taskInfoService.kpiSelectionDisabled)"
                                    [pSelectableRow]="kpiData"
                                    [value]="kpiData"></p-tableCheckbox>
                            </td>
                            <td>
                                <div class="status-circle"
                                    [ngStyle]="{'background-color':dataRepositoryService.routesColour.get(kpiData.route_id)}"
                                    [style.visibility]="dataRepositoryService.routesColour.get(kpiData.route_id) ? 'visible' : 'hidden'">
                                </div>
                                <span>{{ kpiData.route_label }}</span>
                            </td>
                            <td><span [ngStyle]="kpiData.route_state | kpiRouteState">{{kpiData.route_state }}</span></td>
                            <td><span *ngIf="kpiData | showVehicleIcon : selectedKPIRoutes()"><i class="pi pi-truck"
                                        style="color: green" (click)="focusDriverMarkerOnMap(kpiData.route_id)"></i></span></td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="14">
                                <div class="text-center no-record-label">
                                    No Records found.
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            }
        </div>
    </div>
</div>